import { getSmoothStepPath, MarkerType, Position } from "@xyflow/react";

/** Horizontal/vertical stub length from each handle before the path turns. */
export const FLOW_EDGE_PATH_OFFSET = 32;
export const FLOW_EDGE_PATH_BORDER_RADIUS = 62;
/** Stop the path short of the target handle so the arrowhead stays visible in front of the node. */
export const FLOW_EDGE_MARKER_INSET = 18;

export const FLOW_EDGE_STROKE = "#64748b";
export const FLOW_EDGE_STROKE_SELECTED = "#2563eb";
export const FLOW_EDGE_STROKE_WIDTH = 2;
export const FLOW_EDGE_STROKE_WIDTH_SELECTED = 2.5;

export function getFlowEdgeMarkerEnd(selected = false) {
  const color = selected ? FLOW_EDGE_STROKE_SELECTED : FLOW_EDGE_STROKE;
  return {
    type: MarkerType.ArrowClosed,
    width: 20,
    height: 20,
    color,
  };
}

/** Build `url('#…')` for SVG markerEnd (must match React Flow MarkerDefinitions ids). */
export function getFlowMarkerUrl(marker, rfId) {
  if (!marker) return undefined;
  if (typeof marker === "string") return marker;
  const idPrefix = rfId ? `${rfId}__` : "";
  const markerId = `${idPrefix}${Object.keys(marker)
    .sort()
    .map((key) => `${key}=${marker[key]}`)
    .join("&")}`;
  return `url('#${markerId}')`;
}

function insetTargetForMarker(x, y, position, amount) {
  switch (position) {
    case Position.Left:
      return { x: x + amount, y };
    case Position.Right:
      return { x: x - amount, y };
    case Position.Top:
      return { x, y: y + amount };
    case Position.Bottom:
      return { x, y: y - amount };
    default:
      return { x, y };
  }
}

/**
 * Smooth-step path: exits/enters handles along their side (bend outside the node).
 * Returns [path, labelX, labelY, offsetX, offsetY].
 */
export function getFlowEdgePath({
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
}) {
  const target = insetTargetForMarker(
    targetX,
    targetY,
    targetPosition,
    FLOW_EDGE_MARKER_INSET
  );

  return getSmoothStepPath({
    sourceX,
    sourceY,
    targetX: target.x,
    targetY: target.y,
    sourcePosition,
    targetPosition,
    offset: FLOW_EDGE_PATH_OFFSET,
    borderRadius: FLOW_EDGE_PATH_BORDER_RADIUS,
  });
}

export function getFlowEdgeStyle(selected = false) {
  return {
    stroke: selected ? FLOW_EDGE_STROKE_SELECTED : FLOW_EDGE_STROKE,
    strokeWidth: selected ? FLOW_EDGE_STROKE_WIDTH_SELECTED : FLOW_EDGE_STROKE_WIDTH,
    strokeLinecap: "round",
  };
}

export const FLOW_DEFAULT_EDGE_OPTIONS = {
  type: "deletable",
  selectable: true,
  deletable: true,
  markerEnd: getFlowEdgeMarkerEnd(false),
  style: getFlowEdgeStyle(false),
};
